/* eslint-disable jsx-a11y/no-static-element-interactions */
import Image from "next/image"
import { useRouter } from "next/router"
import { useEffect, useLayoutEffect, useState } from "react"
import { useWindowSize } from "rooks"
import Link from "@components/anti/Link"
import {
  linkAbout,
  linkContactUs,
  linkGovernanceAgms,
  linkInvestorProspectus,
  linkOurCommitment,
} from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { rgbDataURL } from "src/mixins"
import { useGeneralStore } from "store"
import { MobileMenuMain } from "./mobile-menu/main-menu"
import { ProductMenu } from "./product-menu"

function Navbar({ theme = "transparent", page }) {
  const { footerData } = useGeneralStore()
  const Router = useRouter()
  const { pathname, asPath, query, locale } = Router

  const { innerHeight } = useWindowSize()
  // On scroll state
  const [navScroll, setNavScroll] = useState(false)
  const useIsomorphicLayoutEffect =
    typeof window !== "undefined" ? useLayoutEffect : useEffect

  useIsomorphicLayoutEffect(() => {
    if (window.scrollY > 5) {
      setNavScroll(true)
    }
  }, [])

  useEffect(() => {
    window.onscroll = () => {
      if (window.scrollY > 5) {
        setNavScroll(true)
      } else {
        setNavScroll(false)
      }
    }
  }, [innerHeight, page])
  // On scroll state

  // Mobile menu
  const [showMobileMenu, setShowMobileMenu] = useState({
    mainMenu: false,
    subMenu: false,
  })
  const handleClickMenu = (item) => {
    if (!item.children) {
      if (item.type === "dropdown") {
        setShowMobileMenu((prev) => ({ ...prev, subMenu: true }))
      } else {
        setShowMobileMenu({ mainMenu: false, subMenu: false })
        setTimeout(() => {
          if (item?.slug?.includes("http") || item?.link?.includes("http"))
            return window.open(item?.slug || item?.link, "_blank")
          return Router.push(item.slug)
        }, 1500)
      }
    }
  }
  useEffect(() => {
    if (showMobileMenu.mainMenu || showMobileMenu.subMenu) {
      document.documentElement.classList.add("no-scroll")
    } else {
      document.documentElement.classList.remove("no-scroll")
    }
  }, [showMobileMenu])
  // Mobile menu

  // Products Mega Menu
  const [megaMenu, setMegaMenu] = useState(false)

  function activeClass(link) {
    const parentSlug = Router.asPath.split("/").filter((x) => x !== "")
    if (link.indexOf(parentSlug[0]) >= 0) {
      return "active"
    }
    return ""
  }
  return (
    <>
      <div
        className={`navbar ${theme} ${
          navScroll || megaMenu ? "is-scrolled" : ""
        }`}
      >
        <div className="d-none d-lg-flex w-100">
          <div className="container">
            <div className="navbar-top">
              <div className="col-left">
                <Link href={footerData?.now_playing_url} target="_blank">
                  {translations[`now_playing_${locale}`]}
                  <i className="cxi-chevron-right ml-1" />
                </Link>
                <Link href="/locations">
                  {translations[`find_cinema_${locale}`]}
                  <i className="cxi-chevron-right ml-1" />
                </Link>
                <Link href={footerData?.mtix_play_store_url} target="_blank">
                  {translations[`download_mtix_${locale}`]}
                  <i className="cxi-chevron-right ml-1" />
                </Link>
              </div>
              <div className="col-right">
                <Link className="link-nav" href="/newsroom">
                  {translations[`news_${locale}`]}
                </Link>
                <Link className="link-nav" href="/career">
                  {translations[`career_${locale}`]}
                </Link>
                <div className="link-nav">
                  <button
                    className={`language-switcher en ${
                      Router.locale === "en" ? "active" : ""
                    }`}
                    onClick={() => {
                      // window.location.href = `/en${Router.asPath}`
                      Router.push({ pathname, query }, asPath, {
                        locale: "en",
                        scroll: false,
                      })
                    }}
                  >
                    en
                  </button>
                  <button
                    className={`language-switcher id ${
                      Router.locale === "id" ? "active" : ""
                    }`}
                    onClick={() => {
                      // window.location.href = `/id${Router.asPath}`
                      Router.push({ pathname, query }, asPath, {
                        locale: "id",
                        scroll: false,
                      })
                    }}
                  >
                    id
                  </button>
                </div>
              </div>
            </div>
            <div className="navbar-main">
              <div className="col-left">
                <Link href="/">
                  <Image
                    src="/img/brand/img_brand-xxi.png"
                    alt="img-logo"
                    width={100}
                    height={45}
                    placeholder="blur"
                    blurDataURL={rgbDataURL(156, 167, 178)}
                    priority
                    className="img-logo"
                  />
                </Link>
              </div>
              <div className="col-right">
                <Link className={activeClass(linkAbout)} href={linkAbout}>
                  {translations[`about_${locale}`]}
                </Link>
                <button
                  className={`nav-menu d-flex align-items-center px-0 ${activeClass(
                    "/products-&-services"
                  )}`}
                  onClick={() => setMegaMenu((prev) => !prev)}
                >
                  {translations[`product_services_${locale}`]}
                  <i className="cxi-chevron-down ml-2" />
                </button>
                <Link
                  className={activeClass(linkGovernanceAgms)}
                  href={linkGovernanceAgms}
                >
                  {translations[`governance_${locale}`]}
                </Link>
                <Link
                  className={activeClass(linkInvestorProspectus)}
                  href={linkInvestorProspectus}
                >
                  {translations[`investors_area_${locale}`]}
                </Link>
                <Link
                  className={activeClass(linkOurCommitment)}
                  href={linkOurCommitment}
                >
                  {translations[`our_commitment_${locale}`]}
                </Link>
                <Link
                  className={activeClass(linkContactUs)}
                  href={linkContactUs}
                >
                  {translations[`contact_us_${locale}`]}
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* Product & Services Mega Menu */}
        <ProductMenu open={megaMenu} setOpen={setMegaMenu} />
        <div className="navbar-mobile d-flex d-lg-none">
          <Link href="/" className="navbar-brand">
            <Image
              src="/img/brand/img_brand-xxi.png"
              alt="img-logo"
              fill
              placeholder="blur"
              blurDataURL={rgbDataURL(156, 167, 178)}
              priority
              className="img-logo"
              sizes="(max-width: 768px) 60vw, (max-width: 1200px) 85vw, 80vw"
            />
          </Link>
          <button
            className="burger-btn"
            onClick={() => setShowMobileMenu({ mainMenu: true })}
          >
            <Image
              src={`/img/icon/img_icon-menu${
                !navScroll && theme !== "white" ? "-white" : ""
              }.svg`}
              alt="icon-menu"
              width={35}
              height={35}
              priority
              className="icon-menu"
            />
          </button>
          <MobileMenuMain
            showMenu={showMobileMenu}
            setShowMenu={setShowMobileMenu}
            handleClickMenu={handleClickMenu}
          />
        </div>
      </div>
      <div
        className={`menu-bg ${megaMenu ? "" : "hide"}`}
        onClick={() => setMegaMenu(false)}
      />
    </>
  )
}

export default Navbar
